import React from 'react';

import Input, { TextAreaProps } from 'antd/es/input';
import { TextAreaRef } from 'antd/es/input/TextArea';

import Button, { ButtonProps } from '@common/react/components/Forms/Button';

import '@commonTuna/react/scss/components/mentionWithExpand.scss';

interface Props extends Omit<TextAreaProps, 'autoSize'> {
	buttonProps?: Omit<ButtonProps, 'onClick'>;
	clearButtonProps?: Omit<ButtonProps, 'onClick'>;
	textareaRef?: React.RefObject<TextAreaRef>;
	customButtons?: React.ReactNode;
	forceExpand?: boolean;
}

const TextareaWithExpand: React.FC<Props> = ({
	buttonProps, clearButtonProps, textareaRef, customButtons, forceExpand, ...props
}) => {
	const [_expand, setExpand] = React.useState(false);
	const expand = forceExpand ?? _expand;
	const style: React.CSSProperties = {
		minHeight: 122,
		height: 'auto',
		resize: 'none',
	};
	const ref = React.useRef<TextAreaRef>(null);

	React.useEffect(() => {
		if (textareaRef) {
			(textareaRef as any).current = ref.current;
			if (ref.current?.resizableTextArea?.textArea) {
				ref.current.resizableTextArea.textArea.selectionStart = typeof props.value === 'string' ? props.value?.length || 0 : 0;
			}
		}
	}, []);

	return <div className="mentions-expand">
		{customButtons}
		{forceExpand === undefined && <Button
			className="btn btn-sm btn-primary"
			{...buttonProps}
			type="button"
			onClick={() => setExpand((prev) => !prev)}
		>
			<i className={`fa fa-${expand ? 'compress' : 'arrows-v'}`} />
		</Button>}
		{clearButtonProps && !props.disabled ? <Button
			className="btn btn-sm btn-primary"
			{...clearButtonProps}
			disabled={!props.value || props.disabled}
			type="button"
			onClick={() => props.onChange?.({ currentTarget: { value: '' }, target: { value: '' } } as any)}
		>
			Clear
		</Button> : null}
		<Input.TextArea
			{...props}
			rows={3}
			ref={ref}
			autoSize={expand}
			style={style}
		/>
	</div>;
};

export default TextareaWithExpand;
